import appendCredentials from '@/utils/appendCredentials'
import { Base, RecommendationsApi } from '@clients/myGeo' // eslint-disable-line no-unused-vars
import getBasePath from '@util/path'
import { AxiosPromise } from 'axios' // eslint-disable-line no-unused-vars

const basePath = getBasePath() + '/my-geo-api'

export default class ExtendedRecommendationsApi extends RecommendationsApi {
  public recommendBaseForUser (lat, lng, options?: any): AxiosPromise<Base> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.recommendBaseForUser('', lat, lng, optionsParam)
  }
}
